import { ArrowUpRight } from "lucide-react";
import { SITE } from "../../lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-white py-10 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <img
            src="/assets/artibir-logo.png"
            alt="Artı Bir Yapı"
            className="h-9 w-auto object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>
        <div className="text-xs text-zinc-500 flex flex-col sm:flex-row gap-4">
          <a
            href={`tel:${SITE.phoneTel}`}
            className="hover:text-white transition-colors"
          >
            {SITE.phoneDisplay}
          </a>
          <span className="hidden sm:inline">·</span>
          <span>{SITE.domain}</span>
          <span className="hidden sm:inline">·</span>
          <span>© {new Date().getFullYear()} Artı Bir Yapı</span>
        </div>
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="text-xs tracking-[0.2em] uppercase font-bold text-zinc-400 hover:text-[#00844A] flex items-center gap-2 transition-colors"
          data-testid="footer-back-top"
        >
          Yukarı çık <ArrowUpRight size={14} />
        </a>
      </div>
    </footer>
  );
};
